// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1a4rG","buttonsContainer":"styles_buttonsContainer___t3Cn","quantity":"styles_quantity__qiFg1","button":"styles_button__Uqw_K"};